import React from 'react';
import { Link } from 'theme-ui';
import { Link as GatsbyLink } from 'gatsby';
import Figure from '../components/Figure';

const serializers = {
  types: {
    image: Figure,
  },
  marks: {
    link: ({ mark, children }) => {
      const { blank, href } = mark;
      return blank ? (
        <Link href={href} target="_blank" rel="noopener">
          {children}
        </Link>
      ) : (
        <Link href={href}>{children}</Link>
      );
    },
    internalLink: ({ mark, children }) => {
      const to = `/${mark.reference.slug.current}`;
      return (
        <Link as={GatsbyLink} to={to}>
          {children}
        </Link>
      );
    },
  },
};

export default serializers;
